import { useEffect, useRef, useState } from "react";
import { GenericComponent } from "../../components/GenericComponent";
import { Gestion } from "../../models/administracion/Gestion";
import { InputComponent } from "../../components/InputComponent";
import { GestionAppService } from "../../service/admin/GestionAppService";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import { useForm } from "react-hook-form";
import { Toolbar } from "primereact/toolbar";
import { Generico } from "../../components/Generico";

export const GestionApp = () => {
    const generic = new GenericComponent();
    const toast = useRef(null);
    const { accionesTbl } = Generico();
    const omodel = new Gestion();
    const [permss, setPermss] = useState(null);
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const [registros, setRegistros] = useState(null);
    const { table, setLoading, setTotalRecords, lazyParams, inDrop, inText } =
        InputComponent({ registers: registros, omodel, generic, errors, control, permss, id: getValues('id') });
    const gestionSrv = new GestionAppService();
    const [dialogGestion, setDialogGestion] = useState(false);
    const [dialogFecha, setDialogFecha] = useState(null);
    const [lista, setLista] = useState(null);
    const [gestion, setGestion] = useState(null);

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);

        let _lazyParams = lazyParams;
        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        gestionSrv.getGestion({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegistros(res.data.registros);
            setLoading(false);
            if (res.data.perss !== undefined) {
                setPermss(res.data.perss);
            }
        });
    }

    const openNew = () => {
        setDialogGestion(true);
        reset(defaultValues);
    }

    const onSubmit = (data) => {
        if (getValues('id') == null) {
            gestionSrv.newGestion(data).then(res => {
                generic.funcSuccess(res, toast);
                setDialogGestion(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
        else {
            gestionSrv.editarGestion(data).then(res => {
                generic.funcSuccess(res, toast);
                setDialogGestion(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
    }

    const editGestion = () => {
        gestionSrv.consultarGestion(gestion?.id).then(res => {
            let _gestion = res.data;
            const lista = { respaldo: generic.sino };

            Object.keys(lista).forEach(function (key) {
                if (_gestion[key] != null) {
                    lista[key].forEach(element => {
                        if (element.cat_id === _gestion[key]) {
                            _gestion[key] = element;
                        }
                    });
                }
            });
            reset(generic.renewValues(_gestion, omodel.model));
            setDialogGestion(true);
        });
    };

    const confirmDelete = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar la información?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminarInformacion()
        });
    }

    const eliminarInformacion = () => {
        setLoading(true);
        gestionSrv.eliminarGestion(gestion?.id).then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        }).finally(() => {
            setLoading(false);
        });
    }

    const confirmEjecutar = () => {
        confirmDialog({
            message: `¿Está seguro de ejecutar?`,
            header: `Confirmación: ${gestion?.nombre}`,
            icon: 'pi pi-exclamation-triangle',
            accept: () => ejecutar()
        });
    }

    const ejecutar = () => {
        setLoading(true);
        gestionSrv.procesar(gestion?.id).then(res => {
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        }).finally(() => {
            setLoading(false);
        });
    }

    const mostrar = () => {
        setLista(null);
        gestionSrv.listar(gestion?.id).then(res => {
            if (res.data.length > 0) {
                setLista(res.data);
                setDialogFecha(true);
            } else {
                res.message = 'Todavía no se han generado ejecuciones exitosas';
                generic.funcSuccess(res, toast);
            }
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar)
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editGestion() } });
        if (permss?.actualizar)
            items.push({ label: 'Ejecutar', icon: 'pi pi-thumbs-up', command: () => { confirmEjecutar(true) } });
        if (permss?.actualizar)
            items.push({ label: 'Historial de ejecuciones exitosas', icon: 'pi pi-bars', command: () => { mostrar() } });
        if (permss?.eliminar)
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });

        return [{ label: 'Opciones', items: items }];
    }

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                <Toolbar className="mb-4" start={generic.leftToolbarTemplate(openNew, 'Nuevo', permss)}
                    end={generic.rightToolbarTemplate(registros, omodel, 'Listado_bases', 'LISTADO BASES/APLICACIONES')}></Toolbar>
                {table({ action01: accionesTbl, reg: setGestion, items: itemsMenu() })}
            </Card>

            <Dialog visible={dialogGestion} header={getValues('id') == null ? "Nuevo" : "Editar"} modal className="p-fluid modal-ssize" onHide={e => setDialogGestion(false)}
                style={{ maxWidth: '800px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {inText('nombre', {}, 6)}
                        {inText('descripcion', {}, 6)}
                        {inDrop('respaldo', generic.sino, { lab: omodel.optionLabel }, 6)}
                        {inText('ruta', {}, 6)}
                        {inText('sigla', {}, 6)}
                    </div>

                    {generic.buttonsForms(setDialogGestion)}
                </form>
            </Dialog>

            <Dialog visible={dialogFecha} header="Lista de Históricos ejecutados" modal className="p-fluid modal-ssize" onHide={e => setDialogFecha(false)}
                style={{ maxWidth: '350px' }}>
                <ul>
                    {lista?.map((e, i) =>
                        <li key={i}>{e.fecha} - {e.estado}</li>
                    )}
                </ul>
            </Dialog>
        </>
    )
}
